(function () {
  const revealNodes = document.querySelectorAll('[data-reveal]');

  if (!revealNodes.length || typeof IntersectionObserver === 'undefined') return;

  const reveal = (entry, observer) => {
    if (!entry.isIntersecting) return;
    entry.target.setAttribute('data-reveal-state', 'visible');
    observer.unobserve(entry.target);
  };

  // Match React ScrollReveal: sections vs card grids use different root margins.
  const defaultObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => reveal(entry, defaultObserver));
    },
    { rootMargin: '-10% 0px' },
  );

  const cardObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => reveal(entry, cardObserver));
    },
    { rootMargin: '0px 0px -8% 0px' },
  );

  /*
   * Early: lead the default section inset slightly so cards start as they
   * approach — still on-screen enough that the motion is visible (70% was
   * finishing below the fold).
   */
  const earlyObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => reveal(entry, earlyObserver));
    },
    { rootMargin: '0px 0px 22% 0px', threshold: 0.01 },
  );

  revealNodes.forEach((node) => {
    if (node.getAttribute('data-reveal') === 'none') {
      node.setAttribute('data-reveal-state', 'visible');
      return;
    }

    const delay = node.getAttribute('data-reveal-delay');
    const duration = node.getAttribute('data-reveal-duration');

    if (delay) {
      node.style.setProperty('--reveal-delay', `${delay}s`);
    }

    if (duration) {
      node.style.setProperty('--reveal-duration', `${duration}s`);
    }

    node.setAttribute('data-reveal-state', 'hidden');

    if (node.hasAttribute('data-reveal-early')) {
      earlyObserver.observe(node);
    } else if (node.getAttribute('data-reveal-variant') === 'card') {
      cardObserver.observe(node);
    } else {
      defaultObserver.observe(node);
    }
  });
})();
